import React from "react";
import { Button, Modal, Form } from "semantic-ui-react";

const HostFormModal = ({
  editStatus,
  openFormModal,
  formData,
  onChangeFormItem,
  onCloseFormModal,
  onSaveHost,
  profileOptions,
  hostOptions,
}) => {
  return (
    <Modal
      closeIcon
      size="small"
      open={openFormModal}
      onClose={onCloseFormModal}
    >
      <Modal.Header>{editStatus ? "Edit Host" : "Add Host"}</Modal.Header>
      <Modal.Content>
        <Form>
          <Form.Field required>
            <label>Host</label>
            <Form.Select
              search
              required
              fluid
              disabled={editStatus}
              value={formData.host}
              options={hostOptions}
              placeholder="Host"
              error={!formData.hostValid}
              onChange={(_e, { value }) => onChangeFormItem("host", value)}
            />
          </Form.Field>
          <Form.Field required>
            <label>Target</label>
            <Form.Input
              placeholder="Target"
              value={formData.target}
              error={!formData.targetValid}
              onChange={(_e, { value }) => onChangeFormItem("target", value)}
            />
          </Form.Field>
          <Form.Field required>
            <label>Profile Name</label>
            <Form.Select
              search
              fluid
              options={profileOptions}
              placeholder="Profile Name"
              value={formData.profile}
              error={!formData.profileValid}
              onChange={(_e, { value }) => onChangeFormItem("profile", value)}
            />
          </Form.Field>
        </Form>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={onCloseFormModal}>Cancel</Button>
        <Button type="submit" positive onClick={onSaveHost}>
          Save
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export { HostFormModal };
